// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"74":"About","275":"Room","337":"Contact","395":"OpenHotel","527":"Site","841":"Events"}[chunkId] || chunkId) + "." + {"32":"209ae680","74":"edd92d6a","275":"b0b39c36","337":"2db59cee","395":"6f971e0b","404":"4c23b42c","527":"1b18ab01","841":"edd92d6a"}[chunkId] + ".css";
};